module.exports = __webpack_public_path__ + "img/monster.655a7b28.jpg";